import * as React from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/shared/libs/utils';

export interface InputProps extends React.ComponentProps<'input'> {
  endIcon?: LucideIcon;
  startIcon?: LucideIcon;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, endIcon: EndIcon, startIcon: StartIcon, type, ...props },
    ref,
  ) => (
    <div className="relative w-full min-w-0">
      {!!StartIcon && (
        <StartIcon
          aria-hidden
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        />
      )}
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-10 w-full rounded-xl border border-input bg-background py-2 text-base ring-offset-background transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          StartIcon ? 'pl-10 pr-3' : 'px-3',
          EndIcon ? 'pr-10' : undefined,
          className,
        )}
        {...props}
      />
      {!!EndIcon && (
        <EndIcon
          aria-hidden
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        />
      )}
    </div>
  ),
);

Input.displayName = 'Input';

export { Input };
